// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cc-acl-subject-suggest__wrapper {
  width: 100%;
}
.cc-acl-subject-suggest__option {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.cc-acl-subject-suggest__option-avatar {
  flex-shrink: 0;
}
.cc-acl-subject-suggest__option-info {
  min-width: 0;
  flex: 1;
}
.cc-acl-subject-suggest__option-name {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cc-acl-subject-suggest__option-meta {
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
  color: var(--g-color-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cc-acl-subject-suggest__wrapper .g-select-list_size_l .g-select-list__option .g-select-list__option-default-label {
  height: auto !important;
  min-height: 64px !important;
  line-height: 1.2 !important;
  padding: 12px 16px !important;
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

.cc-acl-subject-suggest__wrapper .g-select-list_size_m .g-select-list__option .g-select-list__option-default-label {
  height: auto !important;
  min-height: 64px !important;
  line-height: 1.2 !important;
  padding: 12px 16px !important;
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

.cc-acl-subject-suggest__wrapper .g-select-list__option {
  height: auto !important;
  min-height: 64px !important;
  padding: 0 !important;
  display: flex !important;
  align-items: stretch !important;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/AclSubjectSuggest/AclSubjectSuggest.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AADR;AAII;EACI,cAAA;AAFR;AAKI;EACI,YAAA;EACA,OAAA;AAHR;AAMI;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAJR;AAOI;EACI,yCAAA;EACA,6CAAA;EACA,oCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AALR;;AAUA;EACI,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;AAPJ;;AAWA;EACI,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;AARJ;;AAYA;EACI,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,wBAAA;EACA,+BAAA;AATJ","sourcesContent":[".cc-acl-subject-suggest__wrapper {\n  width: 100%;\n}\n.cc-acl-subject-suggest__option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n.cc-acl-subject-suggest__option-avatar {\n  flex-shrink: 0;\n}\n.cc-acl-subject-suggest__option-info {\n  min-width: 0;\n  flex: 1;\n}\n.cc-acl-subject-suggest__option-name {\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.cc-acl-subject-suggest__option-meta {\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n  color: var(--g-color-text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cc-acl-subject-suggest__wrapper .g-select-list_size_l .g-select-list__option .g-select-list__option-default-label {\n  height: auto !important;\n  min-height: 64px !important;\n  line-height: 1.2 !important;\n  padding: 12px 16px !important;\n  display: flex !important;\n  align-items: center !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n.cc-acl-subject-suggest__wrapper .g-select-list_size_m .g-select-list__option .g-select-list__option-default-label {\n  height: auto !important;\n  min-height: 64px !important;\n  line-height: 1.2 !important;\n  padding: 12px 16px !important;\n  display: flex !important;\n  align-items: center !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n.cc-acl-subject-suggest__wrapper .g-select-list__option {\n  height: auto !important;\n  min-height: 64px !important;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: stretch !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
